import { Component, Input, OnInit, Output } from '@angular/core';
import { Empty_LetterRequestCustomer_Review, LetterRequestCustomer_Review } from 'src/app/Interface/LetterRequestCustomer_Review';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterrequestcustomerEvaluateService } from 'src/app/Service/Letter/LetterrequestcustomerEvaluate.service';

@Component({
  selector: 'app-LetterRequestCustomerReviewAnswer',
  templateUrl: './LetterRequestCustomerReviewAnswer.component.html',
  styleUrls: ['./LetterRequestCustomerReviewAnswer.component.scss']
})
export class LetterRequestCustomerReviewAnswerComponent implements OnInit {

  @Input() inner_Letter_id: number = 0

  Token:String=""
  InProccessing: boolean = false

  DataList_Evaluate: Array<LetterRequestCustomer_Review> = []
  Data_Seleted_Delete: LetterRequestCustomer_Review = Empty_LetterRequestCustomer_Review()

  constructor(
    private LetterrequestcustomerEvaluate_Service: LetterrequestcustomerEvaluateService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.ReadData_Evaluate()
  }

  ReadData_Evaluate() {
    this.InProccessing = true
    this.LetterrequestcustomerEvaluate_Service.GetActiveList(
      this.Token,
      this.inner_Letter_id,
    ).subscribe(
      data => {
        this.DataList_Evaluate = data
        this.InProccessing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }



  OnSubmit()
  {
    var Indexer: number = -1
    for (let item of this.DataList_Evaluate)
    {
      if (item.dsc == "0")
      {
        Indexer=this.DataList_Evaluate.indexOf(item)
        break;
      }

    }

    if (Indexer > -1) {
      this.Alertify_Service.ErrorMessage("Answer the question in row "+ (Indexer+1) +".")
    }
    else {
      this.InProccessing=true
      this.LetterrequestcustomerEvaluate_Service.SubmitEvalute(this.DataList_Evaluate, this.Token, this.inner_Letter_id).subscribe(
        data => {
          this.InProccessing=false
          this.Alertify_Service.SuccessMessage("The information was saved successfully.")
        }

      )
    }

  }


}
